import { Table } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React, { useMemo } from 'react';
import { FlatList } from 'react-native';

import { SentOrderDetailResponseNormalized } from '../../../../../store/rateManagement/selector';

import { loadingErrorItemMobile, loadingItemMobile, rowHeight } from './constants';
import { TableCustomerDetailItem } from './item';
import { TableCustomerDetailErrorItem } from './itemError';

export namespace TableCustomerDetailTypes {
  export type TableSelected = 'valid' | 'requiresAttention';

  export interface Props {
    tableSelected: TableSelected;
    sentOrder?: SentOrderDetailResponseNormalized | null;
    loading?: boolean;
    error?: Error;
  }
}

export const TableCustomerDetail: React.FC<TableCustomerDetailTypes.Props> = (props) => {
  const deviceType = useBreakpointValue({ md: 'desktop', sm: 'tablet', base: 'mobile' });

  const loadingItemsMobile = Array.from({ length: 5 }, (_) => loadingItemMobile);
  const loadingErrorItemsMobile = Array.from({ length: 5 }, (_) => loadingErrorItemMobile);

  const content = useMemo(() => {
    if (props.tableSelected === 'valid') {
      return (
        <>
          {deviceType !== 'mobile' ? (
            <Table
              testId="table"
              isLoading={!!props.loading}
              rows={9}
              cols={6}
              rowHeight={rowHeight}
              flex={1}>
              <FlatList
                data={props.sentOrder?.validCustomers}
                keyExtractor={(_, index) => index.toString()}
                style={{ flex: 1 }}
                showsVerticalScrollIndicator={false}
                renderItem={({ item }) => <TableCustomerDetailItem item={item} />}
              />
            </Table>
          ) : (
            <>
              <FlatList
                data={props.sentOrder?.validCustomers}
                windowSize={10}
                maxToRenderPerBatch={4}
                renderItem={({ item }) => (
                  <TableCustomerDetailItem isLoading={!!props.loading} item={item} />
                )}
                keyExtractor={(item) => item.customerId.toString()}
                showsVerticalScrollIndicator={false}
                ListFooterComponent={props.loading ? <>{loadingItemsMobile}</> : null}
              />
            </>
          )}
        </>
      );
    }

    return (
      <>
        {deviceType !== 'mobile' ? (
          <Table
            testId="table"
            isLoading={!!props.loading}
            rows={9}
            cols={5}
            rowHeight={rowHeight}
            flex={1}>
            <FlatList
              data={props.sentOrder?.invalidCustomers}
              windowSize={10}
              maxToRenderPerBatch={4}
              updateCellsBatchingPeriod={5}
              keyExtractor={(_, index) => index.toString()}
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
              renderItem={({ item }) => (
                <TableCustomerDetailErrorItem isLoading={!!props.loading} item={item} />
              )}
            />
          </Table>
        ) : (
          <FlatList
            data={props.sentOrder?.invalidCustomers}
            windowSize={10}
            maxToRenderPerBatch={4}
            renderItem={({ item }) => (
              <TableCustomerDetailErrorItem isLoading={!!props.loading} item={item} />
            )}
            keyExtractor={(item) => item.customerId.toString()}
            showsVerticalScrollIndicator={false}
            ListFooterComponent={props.loading ? <>{loadingErrorItemsMobile}</> : null}
          />
        )}
      </>
    );
  }, [
    props.tableSelected,
    props.loading,
    props.sentOrder?.invalidCustomers,
    props.sentOrder?.validCustomers,
    deviceType,
    loadingErrorItemsMobile,
    loadingItemsMobile,
  ]);

  return content;
};
